export default "__VITE_ASSET__BgoFjB2j__"